if (!customElements.get('swiper-container')) {
  customElements.define('swiper-container', class Slideshow extends HTMLElement {
    constructor() {
      super();

      this.defaultConfig = {
        updateOnWindowResize: true,
        speed: 300,
        a11y: {
          slideRole: '',
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          slideLabelMessage: '{{index}} / {{slidesLength}}'
        },
        on: {
          init: this.onSwiperInit.bind(this),
          slideChange: this.onSlideChange.bind(this),
          resize: this.onSwiperResize.bind(this),
          afterInit: this.afterInit.bind(this)
        }
      }
    }

    connectedCallback() {
      this.settings = JSON.parse(this.getAttribute('data-settings') || '{}');
      this.sectionId = this.dataset.sectionId;
      this.buttons = this.querySelectorAll('.swiper-button');
      this.preventInit = this.hasAttribute('data-prevent-init');
      this.breakpoint = this.dataset.breakpoint ? this.dataset.breakpoint : null;
      this.breakpointDestroy = window.matchMedia(`${this.breakpoint}`).matches;
      this.productCount = this.querySelectorAll('.product-item').length;
      this.nextBtn = this.querySelector('.swiper-button-next-product');
      this.prevBtn = this.querySelector('.swiper-button-prev-product');
      

      if (this.preventInit) {
        if (this.buttons) {
          if (this.buttons) {
            this.buttons.forEach((element) => {
              const boundHandleMouseEnter = (event) => this.handleMouseEnter();
              element.addEventListener('mouseenter', boundHandleMouseEnter);

              element.boundHandleMouseEnter = boundHandleMouseEnter;
            });
          }
        }
        return;
      }

      this.init();
      this.updateArrowsVisibility();
      this.pauseAutoplay();

      window.addEventListener('resize', () => {
        this.updateArrowsVisibility();
      });

      if (!this.breakpoint) return;

      window.addEventListener('resize', () => {
        this.breakpointDestroy = window.matchMedia(`${this.breakpoint}`).matches;

        if (this.breakpointDestroy && !this.swiper) {
          this.swiper = new Swiper(this, Object.assign({}, this.defaultConfig, this.getSettings(this.settings)));
        } else if (!this.breakpointDestroy && this.swiper) {
          this.swiper.destroy();
        }
      });
    }


    updateArrowsVisibility() {
      const screenWidth = window.innerWidth;
      let slidesPerView = 1;
      const swiperConfig = this.getSettings(this.settings);


      if (screenWidth >= 1333 && swiperConfig.breakpoints?.['1333']) {
        slidesPerView = swiperConfig.breakpoints['1333'].slidesPerView;
      } else if (screenWidth >= 1100 && swiperConfig.breakpoints?.['1100']) {
        slidesPerView = swiperConfig.breakpoints['1100'].slidesPerView;
      } else if (screenWidth >= 768 && swiperConfig.breakpoints?.['768']) {
        slidesPerView = swiperConfig.breakpoints['768'].slidesPerView;
      } else if (screenWidth >= 560 && swiperConfig.breakpoints?.['560']) {
        slidesPerView = swiperConfig.breakpoints['560'].slidesPerView;
      }

      if (this.productCount <= slidesPerView) {
        this.nextBtn?.classList.add('hidden');
        this.prevBtn?.classList.add('hidden');
      } else {
        this.nextBtn?.classList.remove('hidden');
        this.prevBtn?.classList.remove('hidden');
      }
    }

    handleMouseEnter() {
      this.init();

      this.buttons.forEach((element) => {
        element.removeEventListener('mouseenter', element.boundHandleMouseEnter);
      });
    }

    init() {
      if (this.getAttribute('data-thumbnails')) {
        const controlSlider = document.querySelector('.swiper-thumbnails');
        const controlSliderConfig = controlSlider.getAttribute('data-settings') ? JSON.parse(controlSlider.getAttribute('data-settings')) : false;

        if (controlSliderConfig) {
          const newControlSlider = new Swiper(controlSlider, controlSliderConfig);

          // Link the thumbnail slider to the main slider
          this.settings.thumbs = {
            swiper: newControlSlider
          };
        }
      }
      
      if (!this.breakpoint) {
        this.swiper = new Swiper(this, Object.assign({}, this.defaultConfig, this.getSettings(this.settings)));
      } else if (this.breakpointDestroy) {
        this.swiper = new Swiper(this, Object.assign({}, this.defaultConfig, this.getSettings(this.settings)));
      }

      // Add event listeners for the main Swiper instance
    }

    pauseAutoplay() {
      if (this.swiper && this.swiper.autoplay.running && this.hasAttribute('data-selector-for-pause')) {
        this.querySelectorAll(`${this.dataset.selectorForPause}`).forEach((element) => {

          element.addEventListener('mouseover', () => {
            this.swiper.autoplay.pause();
          })

          element.addEventListener('mouseleave', () => {
            this.swiper.autoplay.run();
          })
        })
      }
    }

    getSettings(settings) {
      if (settings.controller && settings.controller.control) {
        const controller = document.querySelector(settings.controller.control);

        if (controller) {
          if (controller.swiper) {
            this.settings.controller.control = controller.swiper;
          } else {
            this.settings.controller.control = false;

            controller.addEventListener('swiperInstanceInitialized', () => {
              this.swiper.controller.control = controller.swiper;
            })
          }
        }
      }

      if (settings.pagination?.type === 'custom-tab' && this.sectionId) {
        this.settings.pagination =  {
          el: `.swiper-pagination-${this.sectionId}`,
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span style="background-image: url(' + this.slides[index].dataset.src + ' )"></span></div>';
          }
        }
      }

      return settings;
    }

    onSwiperInit() {
      //Swiper init logic
      this.dispatchEvent(new CustomEvent('swiperInstanceInitialized'));

      if (this.hasAttribute('data-add-unique-id')) {
        setTimeout(() => {
          this.addUniqueId()
        }, 0);
      }
    }

    afterInit(swiper) {
      //Swiper after init logic
    }

    onSlideChange(swiper) {
      if (swiper.el.hasAttribute('data-pause-media')) window.pauseAllMedia();

      //Swiper slideChange logic
      if (swiper.thumbs && swiper.thumbs.swiper) {
        swiper.thumbs.swiper.slideTo(swiper.activeIndex);
      }

      if (swiper.el.hasAttribute('data-main-gallery')) {
        swiper.on("slideChangeTransitionEnd", () => {
          const slide = swiper.slides[swiper.activeIndex];
          const template = slide.querySelector('template');
          if (template) {
            const templateVideo = template.content.querySelector('video');
            if (templateVideo) {
              const playButton = slide.querySelector('.deferred-media__poster');
              playButton.click();
              const slideVideo = slide.querySelector('video');
              slideVideo.play();
            }
          } else {
            window.pauseAllMedia()
          }
        });
      }
    }

    onSwiperResize(event) {
      this.dispatchEvent(new CustomEvent('swiperInstanceResized'));
    }
  });
}
